import React, { useCallback, useState } from "react";

import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popover from "antd/es/popover";
import { useIntl } from "react-intl";

import engagementInfo from "@app/assets/map/legends/engagement-info.svg";
import ButtonLink from "@app/component/ButtonLink";
import Path from "@app/enum/Path";
import SettingPath from "@app/enum/settings/SettingPath";

import styles from "./AlertBadgesLegendCard.module.scss";

interface Props {}

const EngagementInformationPopover: React.FC<Props> = () => {
  const intl = useIntl();
  const [popoverVisible, setPopoverVisibility] = useState<boolean>(false);

  const showPinnedFields = useCallback(() => {
    window.open(`${Path.SETTINGS}/${SettingPath.PINNED_FIELDS}`, "_blank");
    setPopoverVisibility(false);
  }, [setPopoverVisibility]);

  return (
    <>
      <Popover
        content={
          <div className={styles.popover}>
            {intl.formatMessage(
              {
                id: "map.layer.alertBadges.popover.disabled.engagement.alerts.description.body",
                defaultMessage:
                  "We recommend you <strong>enable engagement info</strong> if you have alert badges turned on. Engagement information highlights the last contact and any alert details on the pin preview. You can update this preference any time from <a>Pinned Fields</a>",
                description: "Alert badges popover description body",
              },
              {
                a: (text) => <ButtonLink onClick={showPinnedFields}>{text}</ButtonLink>,
                strong: (text: string) => <strong>{text}</strong>,
              }
            )}
            <br />
            <img alt="Preview" src={engagementInfo} />
          </div>
        }
        onVisibleChange={setPopoverVisibility}
        placement="right"
        title={intl.formatMessage(
          {
            id: "map.layer.alertBadges.description.popover.title",
            defaultMessage: "<strong>Engagement Information</strong>",
            description: "Alert badges description modal title",
          },
          {
            strong: (text: string) => <strong>{text}</strong>,
          }
        )}
        trigger="hover"
        visible={popoverVisible}
      >
        <FontAwesomeIcon className={styles.infoIcon} icon={faInfoCircle} />
      </Popover>
    </>
  );
};

export default EngagementInformationPopover;
